import React from "react";
import BlogIcon from "./BlogIcon";
import { Category } from "../types";

interface CategoryListProps {
  categories: Category[];
  activeCategory: string | null;
  onCategoryChange: (category: string | null) => void;
}

const CategoryList = ({ categories, activeCategory, onCategoryChange }: CategoryListProps) => {

  return (
    <div className="blog-categories" role="list">
      {categories.map((category) => (
        <button
          key={category.label}
          type="button"
          className={activeCategory === category.label ? "is-active" : ""}
          onClick={() =>
            onCategoryChange(
              activeCategory === category.label ? null : category.label
            )
          }
          aria-pressed={activeCategory === category.label}
        >
          <span className="blog-categories__icon"><BlogIcon name={category.icon} /></span>
          {category.label}
        </button>
      ))}
    </div>
  );
};

export default CategoryList;
